// Location: src/styles/miscStyles.js
// Date: 20240929
// Author: R Matthews
// Purpose: Miscellaneous styles
// Description: This file contains miscellaneous styles that do not fit into specific component categories.
// The styles include custom link styles, dividers, contact container, form groups, category menu buttons, 
// nested items, and bullet icons. These styles ensure a consistent look and feel across various parts of 
// the application, enhancing the user experience.

import { makeStyles, tokens } from '@fluentui/react-components';
import { rhemlabs } from '../theme';

export const useMiscStyles = makeStyles({
  link: {
    color: rhemlabs[100],
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  customDivider: {
    height: tokens.spacingL,
  },
  customVerticalDivider: {
    height: tokens.spacingXXL,
  },
  contactContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow4,
    margin: '0 auto',
    padding: tokens.spacingM,
    '@media (max-width: 768px)': {
      width: '90%',
    },
  },
  formGroup: {
    marginBottom: tokens.spacingM,
    width: '400px',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  categoryMenuButton: {
    textDecoration: 'none',
    fontSize: '1.05vw',
  },
  nestedItem: {
    marginLeft: tokens.spacingM,
  },
  bulletIcon: {
    marginRight: tokens.spacingXS,
  },
});